import axios from '../api/axios';
import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router";
import $ from 'jquery';
import { useTranslation } from 'react-i18next';
import emailjs from '@emailjs/browser';

export const Review = () => {
  const { t } = useTranslation();
  const form = useRef();
  const formDataRef = useRef(null);
  const navigate = useNavigate();

  const [isGift, setIsGift] = useState(null);
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [showEmailInput, setShowEmailInput] = useState(false);
  const [formUpdateTrigger, setFormUpdateTrigger] = useState();
  const [experience_id, setExperience_id] = useState(localStorage.getItem("BelPaeseExpressExperience_id"));
  const [order_number, setOrder_number] = useState(null);
  const [submitError, setSubmitError] = useState('');
  const [invalidFieldLabels, setInvalidFieldLabels] = useState([]);
  const [invalidFields, setInvalidFields] = useState([]);


  // FormData con tutti i campi (form + isGift, newsletterEmail), aggiornato a ogni modifica
  useEffect(() => {
    if (!form.current) return;
    const fd = new FormData(form.current);
    fd.append('isGift', isGift ?? '');
    fd.append('newsletterEmail', newsletterEmail);
    fd.append('experience_id', experience_id);
    fd.append('order_number', order_number);
    fd.append('license_key', localStorage.getItem("BelPaeseExpressKey"));
    formDataRef.current = fd;
  }, [formUpdateTrigger, isGift, newsletterEmail]);

  const handleGiftSelection = (value) => {
    setIsGift(value);
    setInvalidFields((prev) => prev.filter((k) => k !== 'isGift'));
    if (value === 'yes') {
      setShowEmailInput(true);
    } else {
      setShowEmailInput(false);
      setNewsletterEmail('');
    }
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    const licenseKey = localStorage.getItem("BelPaeseExpressKey");
    let orderNumber = '';

    // Prima chiamata: recupera order_number se disponibile
    try {
      const orderResponse = await axios.get(`/api/orders/${licenseKey}`, {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
      });

      if (orderResponse.status === 200 && orderResponse.data?.order_number) {
        orderNumber = orderResponse.data.order_number;
        // Imposta il valore nel campo hidden del form
        const orderNumberInput = document.getElementById('order_number');
        if (orderNumberInput) {
          orderNumberInput.value = orderNumber;
        }
      }
    } catch (err) {
      // Ignora errori se la chiamata non va a buon fine
      console.log(err, 'Order number not available, continuing without it');
    }

    // Se ha selezionato "Sì" e ha inserito un'email, fai la chiamata alla newsletter (separata dalla recensione)
    if (isGift === 'yes' && newsletterEmail.trim() !== '') {
      try {
        const language = localStorage.getItem("BelPaeseExpressLanguage") || 'it';
        const newsletterLang = language === 'it' ? 'it' : 'en';
        const username = localStorage.getItem("BelPaeseExpressExperience_username") || '';

        // Chiamata API esterna per la newsletter (separata dalla recensione)
        await axios.post(`/webhook/newsletter/${newsletterLang}`, {
          "newsletter-name": username,
          "newsletter-email": newsletterEmail.trim(),
          "newsletter-acceptance-website-privacy-terms-conditions": "1"
        },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );
      } catch (err) {
        // Ignora errori e continua comunque
        console.log('Newsletter subscription error:', err);
      }
    }

    // Invio email con EmailJS per la recensione (funzionalità separata)
    // Production: emailjs.sendForm('service_iivknq7', 'template_wr73kzx', form.current, 'T8JPw8PVNtZ-pof6K')
    // Test: emailjs.sendForm('service_06g6e3l', 'template_9dt5o6u', form.current, 'T8JPw8PVNtZ-pof6K')
    emailjs.sendForm('service_iivknq7', 'template_wr73kzx', form.current, 'T8JPw8PVNtZ-pof6K')
      .then((result) => {
        returnHome();
      }, (error) => {
      });

    // Chiamata per segnare la recensione come completata
    const fetchData = async () => {
      try {

        await axios.put(`/api/key/${licenseKey}/review`,
          JSON.stringify({
            "token": localStorage.getItem('BelPaeseExpressToken'),
            "review": 1,
            "experience_id": localStorage.getItem('BelPaeseExpressExperience_id')
          }),
          {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*'
            },
          }
        );

      } catch (err) {
        console.log(err);
        if (err.response?.status === 403) {
          localStorage.clear();
          return navigate('/');
        } else {
          console.log('Errore Generico, si prega di riprovare più tardi');
        }
      }

    };

    fetchData().catch(console.error);
  };

  const createReview = async (e) => {
  e.preventDefault();

  // Leggiamo il form dal DOM al momento del submit così la textarea e gli altri campi hanno il valore attuale
  let body = {};
  if (form.current) {
    const fd = new FormData(form.current);
    body = Object.fromEntries(fd.entries());
    body.isGift = body.isGift ?? isGift ?? '';
    body.newsletterEmail = body.newsletterEmail ?? newsletterEmail ?? '';
  }
  // Chiave licenza e experience_id obbligatori per il backend
  const licenseKey = localStorage.getItem('BelPaeseExpressKey');
  body.activation_key = body.activation_key ?? licenseKey ?? '';
  body.license_key = body.license_key ?? licenseKey ?? '';
  const experienceId = localStorage.getItem('BelPaeseExpressExperience_id');
  body.experience_id = body.experience_id ?? (experienceId ? parseInt(experienceId, 10) : null);

  // Validazione: campi obbligatori non possono rimanere vuoti
  const required = [
    { key: 'first_question', label: t('Review1'), value: (body.first_question ?? '').toString().trim() },
    { key: 'second_question', label: t('Review2'), value: (body.second_question ?? '').toString().trim() },
    { key: 'vote', label: t('ReviewRating') || 'Voto', value: (body.vote ?? '').toString().trim() },
    { key: 'message', label: t('Review3'), value: (body.message ?? '').toString().trim() },
    { key: 'isGift', label: t('GiftQuestion'), value: (body.isGift ?? '').toString().trim() },
  ];
  const emptyFields = required.filter((f) => !f.value);
  if (emptyFields.length > 0) {
    setSubmitError('');
    // Sotto il pulsante mostriamo solo second_question e message (no intro, no first_question, no vote, no isGift)
    const labelsToShow = emptyFields
      .filter((f) => f.key !== 'first_question' && f.key !== 'vote' && f.key !== 'isGift')
      .map((f) => f.label);
    setInvalidFieldLabels(labelsToShow);
    setInvalidFields(emptyFields.map((f) => f.key));
    return;
  }

  setSubmitError('');
  setInvalidFieldLabels([]);
  setInvalidFields([]);
  try {
    const response = await axios.post(`/api/reviews/create`, body, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },
    });
    if (response?.status >= 200 && response?.status < 300) {
      returnHome();
    } else {
      setInvalidFieldLabels([]);
      setSubmitError(response?.data?.message || t('ReviewErrorGeneric') || 'Si è verificato un errore. Riprova.');
    }
  } catch (err) {
    console.log(err);
    setInvalidFieldLabels([]);
    const message = err.response?.data?.message || err.response?.data?.error || err.message || (t('ReviewErrorGeneric') || 'Si è verificato un errore. Riprova più tardi.');
    setSubmitError(message);
  }
  };


  function returnHome() {
    return navigate('/review-complete');
  }

  function setAge(age) {
    if ($('#first_question').val().includes(age)) {
      $('#first_question').val($('#first_question').val().replace(age, ''));
    } else {
      $('#first_question').val($('#first_question').val() + " " + age);
    }
    setInvalidFields((prev) => prev.filter((k) => k !== 'first_question'));
    setFormUpdateTrigger((t) => t + 1);
  }

  function setType(type) {
    if ($('#second_question').val().includes(type)) {
      $('#second_question').val($('#second_question').val().replace(type, ''));
      if (type == "Altro") {
        $('#other_answer').val('');
        $('#other_answer').css('display', 'none');
      }
    } else {
      $('#second_question').val($('#second_question').val() + " " + type);
      if (type == "Altro") {
        $('#other_answer').css('display', 'block');
      } else if (!$('#second_question').val().includes('Altro')) {
        $('#other_answer').val('');
        $('#other_answer').css('display', 'none');
      }
    }
    setInvalidFields((prev) => prev.filter((k) => k !== 'second_question'));
    setFormUpdateTrigger((t) => t + 1);
  }

  function setVote(vote) {
    for (let i = 1; i < 6; i++) {
      if (i != vote) {
        $('#vote_' + i).prop('checked', false);
      }
    }
    $('#vote').val('');
    $('#vote').val(vote);
    setInvalidFields((prev) => prev.filter((k) => k !== 'vote'));
    setFormUpdateTrigger((t) => t + 1);
  }

  return (
    <section>
      <div style={{ margin: 'auto', textAlign: 'center', fontFamily: 'Merriweather', boxShadow: "0px 0px 0px rgb(0 0 0 / 0.2)", width: "90%", padding: "10px", backgroundColor: "#7C112B" }}>
        <h1 style={{ color: '#FDB933', fontSize: '18px', display: 'none' }}>{t('ReviewTitle')}</h1>
        <h3 style={{ color: 'white', fontSize: '16px' }}>{t('ReviewDesc')}</h3>
        <form ref={form} onSubmit={(e) => { sendEmail(e); createReview(e); }}>
          <input type="text" name="experience_name" value={localStorage.getItem("BelPaeseExpressExperience_name")} readOnly style={{ display: "none" }} />
          <input type="text" name="username" value={localStorage.getItem("BelPaeseExpressExperience_username")} readOnly style={{ display: "none" }} />
          <input type="text" name="order_number" id="order_number" defaultValue="" style={{ display: "none" }} />

          <div style={{ ...(invalidFields.includes('first_question') ? { border: '2px solid #FDB933', borderRadius: '6px', padding: '8px', marginBottom: '10px' } : { marginBottom: '10px' }) }}>
            <label style={{ color: 'white', fontSize: "15px" }}>{t('Review1')}<br></br></label>
            <div style={{ display: "none" }}>
              <input onChange={() => setAge('>18')} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>{t('Answer11')}</p>
            </div>
            <div style={{ display: "inline-block" }}>
              <input onChange={() => setAge('<20')} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>{t('Answer12')}</p>
            </div>
            <div style={{ display: "inline-block" }}>
              <input onChange={() => setAge('20-40')} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>{t('Answer13')}</p>
            </div>
            <div style={{ display: "inline-block" }}>
              <input onChange={() => setAge('41-60')} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>{t('Answer14')}</p>
            </div>
            <div style={{ display: "inline-block" }}>
              <input onChange={() => setAge('>60')} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px", marginTop: "-10px" }}>{t('Answer15')}</p>
            </div>
            <input style={{ display: "none" }} type="text" name="first_question" id='first_question' />
            {invalidFields.includes('first_question') && (
              <p style={{ color: '#FDB933', fontSize: '12px', marginTop: '6px', marginBottom: 0 }}>{t('ReviewFieldRequired')}</p>
            )}
          </div>
          <br />
          <div style={{ ...(invalidFields.includes('second_question') ? { border: '2px solid #FDB933', borderRadius: '6px', padding: '8px', marginBottom: '10px' } : { marginBottom: '10px' }) }}>
            <label style={{ color: 'white', fontSize: "15px" }}>{t('Review2')}<br></br></label>
          <div style={{ display: "inline-block" }}>
            <input onChange={() => setType('Social')} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>{t('Answer21')}</p>
          </div>
          <div style={{ display: "inline-block" }}>
            <input onChange={() => setType('Web')} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>{t('Answer22')}</p>
          </div>
          <div style={{ display: "inline-block" }}>
            <input onChange={() => setType('Volantini')} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>{t('Answer23')}</p>
          </div>
          <div style={{ display: "inline-block" }}>
            <input onChange={() => setType('Passaparola')} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px", marginTop: "-10px" }}>{t('Answer24')}</p>
          </div>
          <div style={{ display: "inline-block" }}>
            <input onChange={() => setType('Altro')} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px", marginTop: "-10px" }}>{t('Answer25')}</p>
          </div>
            <input type="text" name='other_answer' id='other_answer' style={{ display: "none", width: "95%", height: "30px" }} onChange={() => setFormUpdateTrigger((t) => t + 1)} />
            <input style={{ display: "none" }} type="text" name="second_question" id='second_question' />
            {invalidFields.includes('second_question') && (
              <p style={{ color: '#FDB933', fontSize: '12px', marginTop: '6px', marginBottom: 0 }}>{t('ReviewFieldRequired')}</p>
            )}
          </div>
          <br />
          <div style={{ ...(invalidFields.includes('vote') ? { border: '2px solid #FDB933', borderRadius: '6px', padding: '8px', marginBottom: '10px' } : { marginBottom: '10px' }) }}>
            <label style={{ color: 'white', fontSize: "15px" }}>{t('Review3')}<br></br></label>
            <div style={{ display: "inline-block" }}>
              <input id='vote_1' onChange={() => setVote(1)} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>1</p>
              <input id='vote_2' onChange={() => setVote(2)} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>2</p>
              <input id='vote_3' onChange={() => setVote(3)} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>3</p>
              <input id='vote_4' onChange={() => setVote(4)} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>4</p>
              <input id='vote_5' onChange={() => setVote(5)} style={{ width: "15px", height: "15px" }} type="checkbox" /><p style={{ color: "white", display: "inline-block", marginLeft: "5px", marginRight: "5px" }}>5</p>
            </div>
            <textarea type="text" name='vote' id='vote' style={{ width: "95%", height: "15px", padding: "10px", fontFamily: "Merriweather", display: "none" }} placeholder={t('Answer31')} />
            {invalidFields.includes('vote') && (
              <p style={{ color: '#FDB933', fontSize: '12px', marginTop: '6px', marginBottom: 0 }}>{t('ReviewFieldRequired')}</p>
            )}
          </div>
          <div style={{ marginBottom: '10px', ...(invalidFields.includes('message') ? { border: '2px solid #FDB933', borderRadius: '6px', padding: '8px' } : {}) }}>
            <textarea type="text" name='message' id='message' style={{ width: "95%", height: "72px", padding: "10px", fontFamily: "Merriweather" }} placeholder={t('Answer32')} required onChange={() => { setInvalidFields((prev) => prev.filter((k) => k !== 'message')); setFormUpdateTrigger((t) => t + 1); }} />
            {invalidFields.includes('message') && (
              <p style={{ color: '#FDB933', fontSize: '12px', marginTop: '6px', marginBottom: 0 }}>{t('ReviewFieldRequired')}</p>
            )}
          </div>
          <br /><br />

          {/* Sezione domanda regalo - dopo la recensione, prima del pulsante invia */}
          <div style={{ marginBottom: '20px', ...(invalidFields.includes('isGift') ? { border: '2px solid #FDB933', borderRadius: '6px', padding: '8px' } : {}) }}>
            <label style={{ color: 'white', fontSize: "15px", display: 'block', marginBottom: '15px' }}>
              {t('GiftQuestion')}
            </label>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginBottom: '15px', gap: '10px' }}>
              <button
                type="button"
                onClick={() => handleGiftSelection('yes')}
                style={{
                  padding: "10px",
                  paddingRight: "25px",
                  paddingLeft: "25px",
                  borderRadius: "0px",
                  border: `2px solid ${isGift === 'yes' ? '#FDB933' : 'white'}`,
                  backgroundColor: isGift === 'yes' ? '#FDB933' : 'transparent',
                  color: isGift === 'yes' ? '#7C112B' : 'white',
                  fontFamily: "Merriweather",
                  fontSize: "13px",
                  cursor: 'pointer'
                }}
              >
                {t('Yes')}
              </button>
              <button
                type="button"
                onClick={() => handleGiftSelection('no')}
                style={{
                  padding: "10px",
                  paddingRight: "25px",
                  paddingLeft: "25px",
                  borderRadius: "0px",
                  border: `2px solid ${isGift === 'no' ? '#FDB933' : 'white'}`,
                  backgroundColor: isGift === 'no' ? '#FDB933' : 'transparent',
                  color: isGift === 'no' ? '#7C112B' : 'white',
                  fontFamily: "Merriweather",
                  fontSize: "13px",
                  cursor: 'pointer'
                }}
              >
                {t('No')}
              </button>
            </div>
            {invalidFields.includes('isGift') && (
              <p style={{ color: '#FDB933', fontSize: '12px', marginTop: '6px', marginBottom: 0 }}>{t('ReviewFieldRequired')}</p>
            )}

            {showEmailInput && (
              <div style={{ marginBottom: '20px' }}>
                <label htmlFor="newsletter_email" style={{ color: 'white', fontSize: "15px", display: 'block', marginBottom: '10px' }}>
                  {t('NewsletterEmailLabel')}
                </label>
                <input
                  type="email"
                  id="newsletter_email"
                  value={newsletterEmail}
                  onChange={(e) => setNewsletterEmail(e.target.value)}
                  placeholder={t('NewsletterEmailPlaceholder')}
                  style={{
                    padding: "10px",
                    width: "80%",
                    border: "2px solid #FDB933",
                    fontFamily: "Merriweather",
                    fontSize: "14px"
                  }}
                />
                <p style={{ color: 'white', fontSize: "12px", marginTop: '5px' }}>
                  {t('NewsletterEmailOptional')}
                </p>
              </div>
            )}
          </div>

          {(submitError || invalidFieldLabels.length > 0) && (
            <div style={{ marginBottom: '15px', marginTop: '10px' }}>
              {submitError && invalidFieldLabels.length === 0 && (
                <p style={{ color: '#FDB933', fontSize: '14px', fontWeight: 600, marginBottom: '6px' }}>
                  {submitError}
                </p>
              )}
              {invalidFieldLabels.length > 0 && (
                <div style={{ color: 'white', fontSize: '14px' }}>
                  {invalidFieldLabels.map((label) => (
                    <div key={label} style={{ marginTop: '4px' }}>{label}</div>
                  ))}
                </div>
              )}
            </div>
          )}
          <input type="submit" onClick={createReview} value={t('ReviewButton')} style={{
            padding: "10px", paddingRight: "25px", paddingLeft: "25px", borderRadius: "0px", border: "2px solid #FDB933",
            backgroundColor: "#FDB933", color: "#7C112B", fontFamily: "Merriweather", fontSize: "13px"
          }} />
          <br />
         
          <br />
          <p style={{ color: "white", fontSize: "12px" }}>{t('ReviewFinalText')}</p>
        </form>
      </div>
    </section>
  );
};

export default Review;
